import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkTertiaryButton, UitkPrimaryButton, UitkButtonSize } from 'uitk-react-button';
import { UitkToolbar } from 'uitk-react-toolbar';
import styles from '../uitk-date-selector.css';
import { UitkAlert } from '../uitk-alert.esm.js';
var getClassNameList = classNames.bind(styles);
var ComposableCalendar = function (props) {
  var children = props.children,
    ctaItems = props.ctaItems,
    dateSelectorPlayback = props.dateSelectorPlayback,
    showPlayback = props.showPlayback,
    calendarWrapper = props.calendarWrapper,
    alertTemplateComponent = props.alertTemplateComponent,
    alertTemplateData = props.alertTemplateData,
    hideFooter = props.hideFooter,
    navType = props.navType;
  var submitCta = ctaItems.submitCta,
    clearDatesCta = ctaItems.clearDatesCta;
  var CalendarWrapper = React.useMemo(function () {
    return calendarWrapper ? calendarWrapper.component : React.Fragment;
  }, []);
  var navTypeIsScrolling = navType === 'scrolling';
  var baseDateSelectorPlaybackWrapperClass = 'uitk-date-selector-playback-wrapper';
  var dateSelectorPlaybackWrapperCssClasses = {
    'uitk-date-selector-playback-wrapper-sticky': navTypeIsScrolling
  };
  var baseDateSelectorFooterClass = 'uitk-date-selector-footer';
  var dateSelectorFooterCssClasses = {
    'uitk-date-selector-footer-sticky': navTypeIsScrolling
  };
  return React.createElement(React.Fragment, null, React.createElement(CalendarWrapper, __assign({}, calendarWrapper === null || calendarWrapper === void 0 ? void 0 : calendarWrapper.props), showPlayback && React.createElement("div", {
    "data-testid": "date-selector-playback-wrapper",
    className: getClassNameList(baseDateSelectorPlaybackWrapperClass, dateSelectorPlaybackWrapperCssClasses)
  }, React.createElement(UitkToolbar, null, dateSelectorPlayback)), React.createElement("div", null, children)), alertTemplateComponent && !navTypeIsScrolling && React.createElement(UitkAlert, {
    alertTemplateComponent: alertTemplateComponent,
    alertTemplateData: alertTemplateData
  }), !hideFooter && React.createElement(UitkSpacing, {
    padding: {
      inline: 'two',
      block: 'three'
    }
  }, React.createElement("footer", {
    className: getClassNameList(baseDateSelectorFooterClass, dateSelectorFooterCssClasses),
    "data-testid": "date-selector-footer"
  }, alertTemplateComponent && navTypeIsScrolling && React.createElement(UitkAlert, {
    alertTemplateComponent: alertTemplateComponent,
    alertTemplateData: alertTemplateData
  }), React.createElement(UitkLayoutFlex, {
    space: "three",
    justifyContent: navTypeIsScrolling ? 'center' : 'end'
  }, clearDatesCta.handler && !navTypeIsScrolling && React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkTertiaryButton, {
    onClick: clearDatesCta.handler,
    "aria-disabled": clearDatesCta.disabled,
    tabIndex: clearDatesCta.disabled ? -1 : 0
  }, clearDatesCta.label)), submitCta.handler && React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkPrimaryButton, {
    "data-stid": "apply-date-selector",
    disabled: submitCta.disabled,
    onClick: submitCta.handler,
    isFullWidth: navTypeIsScrolling,
    size: navTypeIsScrolling ? UitkButtonSize.LARGE : UitkButtonSize.MEDIUM
  }, submitCta.label))))));
};
export { ComposableCalendar };